import React from 'react';
import { Button } from '../atoms/button';
import { Label } from '../atoms/label';

export const LabelButtonForm = (props) => {
    
    return(
        <div>
            <Label label={props.label} className={props.isWideTablet ? "unregisteredSp" : "unregisteredPc"}/>
            <Button 
                onClick={props.onClick}
                buttonText={props.buttonText}
                className={props.isWideTablet ? "entryBtnStyleSp" : "entryBtnStylePc"}
                href={props.href}
                //style={styles.btnStyle}
            />
        </div>
    );
}
const styles = {

}
